module.exports = "h1 {\r\n    color: #00579e;\r\n    font-size: 2em;\r\n}\r\n\r\n.lui-button-icon {\r\n    color: #00a0ea;\r\n    font-size: 0.9em !important;\r\n    border: 0;\r\n    background-color: transparent;\r\n    display: inline-block;\r\n    padding: 2px 6px 3px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app_manager/app_element/communication/top-communication/top-communication.component.css
// module id = ./src/app/app_manager/app_element/communication/top-communication/top-communication.component.css
// module chunks = main